<template>
	<div id="vtv-show" class="row-v2">
		<div class="col left">
			<div class="col__box">
				<!-- <d-player :options="options" ref="player" :style="player.style" class="dplayer"></d-player> -->
			</div>
		</div>
		<div class="col right">
			<div class="col__box">
				<vtv-channels-component />
			</div>
		</div>
	</div>
</template>

<script>
	// import 'vue-dplayer/dist/vue-dplayer.css';
	// import VueDPlayer from 'vue-dplayer';
	// import DPlayer from 'dplayer';
	export default {
		name: 'vtv-show',
		components: {
			// 'd-player': VueDPlayer,
			// 'vtv-channels-component': require('./components/channels.vue').default,
		},
		data () {
			return {
				options: {
					autoplay: true,
					preload: 'auto',
					theme: '#ff0000',
					hotkey: true,
					logo: '/images/logo.jpg',
					screenshot: false,
					volume: 2,
					mutex: true,
					video: {
						url: 'http://1.54.157.106:4022/udp/225.1.1.245:30120',
						// url: 'https://cdn-livestream-live.vtvgiaitri.vn/vtv2.smil/playlist.m3u8',
						// url: 'https://hjyjrvmlsk.vcdn.com.vn/hls/elgfjdh/index.m3u8',
					},
					subtitle: {
						url: ``,
						type: 'webvtt',
						fontSize: '25px',
						bottom: '3%',
						color: '#b7daff'
					}
				},
				player: {
					style: {
						height: 'inherit',
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
#vtv-show {
	$left-width: 800px;
	$right-width: 400px;
	width: $left-width + $right-width;
	margin: auto;
	.col {
		&.left {
			width: $left-width;
		}
		&.right {
			width: $right-width;
		}
	}
}
</style>
